export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8187.058930ab.jpg";